import { useState } from "react";
import { faqItems } from "@/mocks/news";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-question-answer-line" /> FAQ
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              关于追瓜，你可能想问
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-500">
              信源、更新频率、假消息处置与投稿方式，这些我们常被问到的问题，
              一次性在这里说清楚，让你安心吃瓜。
            </p>
            <a
              href="mailto:support@zuikuaichigua.cn"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-lg border border-primary-200 bg-primary-50 px-5 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100 cursor-pointer"
            >
              <i className="ri-mail-send-line" /> support@zuikuaichigua.cn
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqItems.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div
                    key={f.q}
                    className={
                      "overflow-hidden rounded-xl border transition-colors " +
                      (open ? "border-primary-200 bg-background-100" : "border-background-200 bg-background-100/50")
                    }
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? null : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={
                            "flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-bold " +
                            (open ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-secondary-700")
                          }
                        >
                          {i + 1}
                        </span>
                        <span className={"font-heading text-sm font-bold md:text-[15px] " + (open ? "text-foreground-950" : "text-foreground-800")}>
                          {f.q}
                        </span>
                      </span>
                      <i
                        className={
                          "shrink-0 text-lg text-primary-600 transition-transform " +
                          (open ? "ri-subtract-line" : "ri-add-line")
                        }
                      />
                    </button>
                    {open && (
                      <div className="border-t border-background-200/70 px-5 py-4">
                        <p className="pl-9 text-sm leading-7 text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}